/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { Add } from './Add';
import { AddCircle } from './AddCircle';
import { AlertsOff } from './AlertsOff';
import { AlertsOn } from './AlertsOn';
import { Android } from './Android';
import { AndroidBack } from './AndroidBack';
import { AndroidForward } from './AndroidForward';
import { AndroidShare } from './AndroidShare';
import { Apple } from './Apple';
import { ApplePay } from './ApplePay';
import { ArrowDown } from './ArrowDown';
import { ArrowLeft } from './ArrowLeft';
import { ArrowLeftRight } from './ArrowLeftRight';
import { ArrowRight } from './ArrowRight';
import { ArrowUp } from './ArrowUp';
import { ArrowUpDown } from './ArrowUpDown';
import { Atm } from './Atm';
import { Bank } from './Bank';
import { BankDisabled } from './BankDisabled';
import { BarChart } from './BarChart';
import { Barcode } from './Barcode';
import { Bill } from './Bill';
import { BillSplit } from './BillSplit';
import { Calculator } from './Calculator';
import { Calendar } from './Calendar';
import { Camera } from './Camera';
import { Cancel } from './Cancel';
import { CancelCircle } from './CancelCircle';
import { CancelFilled } from './CancelFilled';
import { Car } from './Car';
import { CardCanceled } from './CardCanceled';
import { CardDamaged } from './CardDamaged';
import { CardLocked } from './CardLocked';
import { CardNumber } from './CardNumber';
import { CardNumberDark } from './CardNumberDark';
import { CardUnlocked } from './CardUnlocked';
import { Cash } from './Cash';
import { CashStack } from './CashStack';
import { CentSymbol } from './CentSymbol';
import { Chat } from './Chat';
import { Check } from './Check';
import { CheckboxEmpty } from './CheckboxEmpty';
import { CheckboxSelected } from './CheckboxSelected';
import { Checkmark } from './Checkmark';
import { CheckmarkCircle } from './CheckmarkCircle';
import { CheckmarkFilled } from './CheckmarkFilled';
import { CheckmarkHeavy } from './CheckmarkHeavy';
import { ChevronDown } from './ChevronDown';
import { ChevronDownCircle } from './ChevronDownCircle';
import { ChevronLeft } from './ChevronLeft';
import { ChevronLeftCircle } from './ChevronLeftCircle';
import { ChevronRight } from './ChevronRight';
import { ChevronRightCircle } from './ChevronRightCircle';
import { ChevronUp } from './ChevronUp';
import { ChevronUpCircle } from './ChevronUpCircle';
import { ChimeC } from './ChimeC';
import { ChimePlus } from './ChimePlus';
import { Circle } from './Circle';
import { CircleFilled } from './CircleFilled';
import { CircleSelected } from './CircleSelected';
import { CircularArrow } from './CircularArrow';
import { Clock } from './Clock';
import { Close } from './Close';
import { Coffee } from './Coffee';
import { Coffees } from './Coffees';
import { Coins } from './Coins';
import { Controls } from './Controls';
import { Copy } from './Copy';
import { CreditCard } from './CreditCard';
import { CreditCardStack } from './CreditCardStack';
import { CreditScore } from './CreditScore';
import { Desktop } from './Desktop';
import { Diamond } from './Diamond';
import { Dining } from './Dining';
import { Document } from './Document';
import { DocumentStack } from './DocumentStack';
import { DollarSymbol } from './DollarSymbol';
import { Drag } from './Drag';
import { Earth } from './Earth';
import { Edit } from './Edit';
import { EditAlt } from './EditAlt';
import { Electricity } from './Electricity';
import { Envelope } from './Envelope';
import { EnvelopeOpen } from './EnvelopeOpen';
import { Error } from './Error';
import { Expand } from './Expand';
import { ExpandX } from './ExpandX';
import { ExpandY } from './ExpandY';
import { Experian } from './Experian';
import { EyeClosed } from './EyeClosed';
import { EyeImpaired } from './EyeImpaired';
import { EyeOpen } from './EyeOpen';
import { Facebook } from './Facebook';
import { Family } from './Family';
import { File } from './File';
import { FileStack } from './FileStack';
import { Folder } from './Folder';
import { GasPump } from './GasPump';
import { Gear } from './Gear';
import { GearChecking } from './GearChecking';
import { GearCheckingCard } from './GearCheckingCard';
import { GearCreditBuilder } from './GearCreditBuilder';
import { Gift } from './Gift';
import { GiftTag } from './GiftTag';
import { Globe } from './Globe';
import { Hand } from './Hand';
import { HandStar } from './HandStar';
import { Handshake } from './Handshake';
import { HatGlasses } from './HatGlasses';
import { Heart } from './Heart';
import { HeartFilled } from './HeartFilled';
import { Help } from './Help';
import { HelpChat } from './HelpChat';
import { HelpFilled } from './HelpFilled';
import { Home } from './Home';
import { HomeAlt } from './HomeAlt';
import { Hourglass } from './Hourglass';
import { Hyperlink } from './Hyperlink';
import { Image } from './Image';
import { Inbox } from './Inbox';
import { Infinite } from './Infinite';
import { Info } from './Info';
import { Instagram } from './Instagram';
import { IosBack } from './IosBack';
import { IosForward } from './IosForward';
import { IosShare } from './IosShare';
import { Key } from './Key';
import { Laptop } from './Laptop';
import { LightBulb } from './LightBulb';
import { LightBulbFilled } from './LightBulbFilled';
import { Lightning } from './Lightning';
import { LineChart } from './LineChart';
import { LinkedIn } from './LinkedIn';
import { List } from './List';
import { Location } from './Location';
import { LocationFilled } from './LocationFilled';
import { Lock } from './Lock';
import { MagnifyingGlass } from './MagnifyingGlass';
import { MapPin } from './MapPin';
import { MapPinAtm } from './MapPinAtm';
import { Meals } from './Meals';
import { Medal } from './Medal';
import { Membership } from './Membership';
import { MembershipFilled } from './MembershipFilled';
import { MembershipNull } from './MembershipNull';
import { Menu } from './Menu';
import { MenuCircle } from './MenuCircle';
import { Messages } from './Messages';
import { MicroChevronRight } from './MicroChevronRight';
import { MicroClose } from './MicroClose';
import { MobileDevice } from './MobileDevice';
import { Moon } from './Moon';
import { MoonFilled } from './MoonFilled';
import { MoreCircle } from './MoreCircle';
import { MoreHorizontal } from './MoreHorizontal';
import { MoreHorizontalFilled } from './MoreHorizontalFilled';
import { MoreVertical } from './MoreVertical';
import { MoreVerticalFilled } from './MoreVerticalFilled';
import { MoveModuleBottom } from './MoveModuleBottom';
import { MoveModuleTop } from './MoveModuleTop';
import { MoveMoney } from './MoveMoney';
import { MoveMoneyAlt } from './MoveMoneyAlt';
import { MovePayMoney } from './MovePayMoney';
import { MoveToTop } from './MoveToTop';
import { OpenBook } from './OpenBook';
import { PauseCircle } from './PauseCircle';
import { People } from './People';
import { PeopleAlt } from './PeopleAlt';
import { PeopleAltNull } from './PeopleAltNull';
import { PeopleGroup } from './PeopleGroup';
import { Person } from './Person';
import { PersonAlt } from './PersonAlt';
import { Pin } from './Pin';
import { PlayCircle } from './PlayCircle';
import { Products } from './Products';
import { Profile } from './Profile';
import { QrCode } from './QrCode';
import { Quote } from './Quote';
import { Receipt } from './Receipt';
import { Remove } from './Remove';
import { RemoveCircle } from './RemoveCircle';
import { Rent } from './Rent';
import { RequestMoney } from './RequestMoney';
import { Restaurant } from './Restaurant';
import { Rocket } from './Rocket';
import { RoundUp } from './RoundUp';
import { SaveWhenIGetPaid } from './SaveWhenIGetPaid';
import { Savings } from './Savings';
import { SavingsAlt } from './SavingsAlt';
import { Scissors } from './Scissors';
import { Send } from './Send';
import { SendMoney } from './SendMoney';
import { SendRotated } from './SendRotated';
import { Shield } from './Shield';
import { ShieldDollar } from './ShieldDollar';
import { Shine } from './Shine';
import { SolidArrowDown } from './SolidArrowDown';
import { SolidArrowRight } from './SolidArrowRight';
import { Speakerphone } from './Speakerphone';
import { SpendingCard } from './SpendingCard';
import { SpendingCardDark } from './SpendingCardDark';
import { SpotMe } from './SpotMe';
import { SpotMeGear } from './SpotMeGear';
import { Sprout } from './Sprout';
import { Star } from './Star';
import { StarFilled } from './StarFilled';
import { StarHalf } from './StarHalf';
import { SteeringWheel } from './SteeringWheel';
import { StopCircle } from './StopCircle';
import { Storefront } from './Storefront';
import { Sun } from './Sun';
import { SunFilled } from './SunFilled';
import { SunHalf } from './SunHalf';
import { SupportHeadset } from './SupportHeadset';
import { TabbedFolder } from './TabbedFolder';
import { Tabs } from './Tabs';
import { Tag } from './Tag';
import { TaskList } from './TaskList';
import { TaxDocuments } from './TaxDocuments';
import { TaxFiling } from './TaxFiling';
import { TaxReturn } from './TaxReturn';
import { Telephone } from './Telephone';
import { Toggle } from './Toggle';
import { TransactionAlert } from './TransactionAlert';
import { Trash } from './Trash';
import { Twitter } from './Twitter';
import { Ufo } from './Ufo';
import { Unlock } from './Unlock';
import { Urgent } from './Urgent';
import { UrgentFilled } from './UrgentFilled';
import { Wallet } from './Wallet';


export const icons = {
  add: Add,
  add_circle: AddCircle,
  alerts_off: AlertsOff,
  alerts_on: AlertsOn,
  android: Android,
  android_back: AndroidBack,
  android_forward: AndroidForward,
  android_share: AndroidShare,
  apple: Apple,
  apple_pay: ApplePay,
  arrow_down: ArrowDown,
  arrow_left: ArrowLeft,
  arrow_left_right: ArrowLeftRight,
  arrow_right: ArrowRight,
  arrow_up: ArrowUp,
  arrow_up_down: ArrowUpDown,
  atm: Atm,
  bank: Bank,
  bank_disabled: BankDisabled,
  bar_chart: BarChart,
  barcode: Barcode,
  bill: Bill,
  bill_split: BillSplit,
  calculator: Calculator,
  calendar: Calendar,
  camera: Camera,
  /** @deprecated **/
  cancel: Cancel,
  cancel_circle: CancelCircle,
  cancel_filled: CancelFilled,
  car: Car,
  card_canceled: CardCanceled,
  card_damaged: CardDamaged,
  card_locked: CardLocked,
  card_number: CardNumber,
  card_number_dark: CardNumberDark,
  card_unlocked: CardUnlocked,
  cash: Cash,
  cash_stack: CashStack,
  cent_symbol: CentSymbol,
  chat: Chat,
  check: Check,
  checkbox_empty: CheckboxEmpty,
  checkbox_selected: CheckboxSelected,
  checkmark: Checkmark,
  checkmark_circle: CheckmarkCircle,
  checkmark_filled: CheckmarkFilled,
  checkmark_heavy: CheckmarkHeavy,
  chevron_down: ChevronDown,
  chevron_down_circle: ChevronDownCircle,
  chevron_left: ChevronLeft,
  chevron_left_circle: ChevronLeftCircle,
  chevron_right: ChevronRight,
  chevron_right_circle: ChevronRightCircle,
  chevron_up: ChevronUp,
  chevron_up_circle: ChevronUpCircle,
  chime_c: ChimeC,
  /** @deprecated **/
  chime_plus: ChimePlus,
  circle: Circle,
  circle_filled: CircleFilled,
  circle_selected: CircleSelected,
  circular_arrow: CircularArrow,
  clock: Clock,
  close: Close,
  coffee: Coffee,
  /** @deprecated **/
  coffees: Coffees,
  coins: Coins,
  controls: Controls,
  copy: Copy,
  credit_card: CreditCard,
  credit_card_stack: CreditCardStack,
  credit_score: CreditScore,
  desktop: Desktop,
  diamond: Diamond,
  dining: Dining,
  document: Document,
  document_stack: DocumentStack,
  dollar_symbol: DollarSymbol,
  drag: Drag,
  earth: Earth,
  edit: Edit,
  edit_alt: EditAlt,
  electricity: Electricity,
  envelope: Envelope,
  envelope_open: EnvelopeOpen,
  error: Error,
  expand: Expand,
  expand_x: ExpandX,
  expand_y: ExpandY,
  experian: Experian,
  eye_closed: EyeClosed,
  eye_impaired: EyeImpaired,
  eye_open: EyeOpen,
  facebook: Facebook,
  family: Family,
  file: File,
  file_stack: FileStack,
  folder: Folder,
  gas_pump: GasPump,
  gear: Gear,
  gear_checking: GearChecking,
  /** @deprecated **/
  gear_checking_card: GearCheckingCard,
  gear_credit_builder: GearCreditBuilder,
  gift: Gift,
  gift_tag: GiftTag,
  globe: Globe,
  hand: Hand,
  hand_star: HandStar,
  handshake: Handshake,
  hat_glasses: HatGlasses,
  heart: Heart,
  heart_filled: HeartFilled,
  help: Help,
  help_chat: HelpChat,
  help_filled: HelpFilled,
  home: Home,
  /** @deprecated **/
  home_alt: HomeAlt,
  hourglass: Hourglass,
  hyperlink: Hyperlink,
  image: Image,
  inbox: Inbox,
  infinite: Infinite,
  info: Info,
  instagram: Instagram,
  ios_back: IosBack,
  ios_forward: IosForward,
  ios_share: IosShare,
  key: Key,
  laptop: Laptop,
  light_bulb: LightBulb,
  /** @deprecated **/
  light_bulb_filled: LightBulbFilled,
  lightning: Lightning,
  line_chart: LineChart,
  linked_in: LinkedIn,
  list: List,
  location: Location,
  location_filled: LocationFilled,
  lock: Lock,
  magnifying_glass: MagnifyingGlass,
  map_pin: MapPin,
  map_pin_atm: MapPinAtm,
  /** @deprecated **/
  meals: Meals,
  medal: Medal,
  membership: Membership,
  membership_filled: MembershipFilled,
  membership_null: MembershipNull,
  menu: Menu,
  menu_circle: MenuCircle,
  messages: Messages,
  micro_chevron_right: MicroChevronRight,
  micro_close: MicroClose,
  mobile_device: MobileDevice,
  moon: Moon,
  moon_filled: MoonFilled,
  more_circle: MoreCircle,
  more_horizontal: MoreHorizontal,
  /** @deprecated **/
  more_horizontal_filled: MoreHorizontalFilled,
  more_vertical: MoreVertical,
  /** @deprecated **/
  more_vertical_filled: MoreVerticalFilled,
  move_module_bottom: MoveModuleBottom,
  move_module_top: MoveModuleTop,
  move_money: MoveMoney,
  move_money_alt: MoveMoneyAlt,
  move_pay_money: MovePayMoney,
  move_to_top: MoveToTop,
  open_book: OpenBook,
  pause_circle: PauseCircle,
  people: People,
  /** @deprecated **/
  people_alt: PeopleAlt,
  /** @deprecated **/
  people_alt_null: PeopleAltNull,
  people_group: PeopleGroup,
  person: Person,
  /** @deprecated **/
  person_alt: PersonAlt,
  pin: Pin,
  play_circle: PlayCircle,
  products: Products,
  profile: Profile,
  qr_code: QrCode,
  quote: Quote,
  receipt: Receipt,
  remove: Remove,
  remove_circle: RemoveCircle,
  rent: Rent,
  request_money: RequestMoney,
  restaurant: Restaurant,
  rocket: Rocket,
  round_up: RoundUp,
  save_when_i_get_paid: SaveWhenIGetPaid,
  savings: Savings,
  savings_alt: SavingsAlt,
  scissors: Scissors,
  send: Send,
  send_money: SendMoney,
  send_rotated: SendRotated,
  shield: Shield,
  shield_dollar: ShieldDollar,
  shine: Shine,
  /** @deprecated **/
  solid_arrow_down: SolidArrowDown,
  /** @deprecated **/
  solid_arrow_right: SolidArrowRight,
  speakerphone: Speakerphone,
  spending_card: SpendingCard,
  spending_card_dark: SpendingCardDark,
  spot_me: SpotMe,
  spot_me_gear: SpotMeGear,
  sprout: Sprout,
  star: Star,
  star_filled: StarFilled,
  star_half: StarHalf,
  steering_wheel: SteeringWheel,
  stop_circle: StopCircle,
  storefront: Storefront,
  sun: Sun,
  sun_filled: SunFilled,
  sun_half: SunHalf,
  support_headset: SupportHeadset,
  tabbed_folder: TabbedFolder,
  tabs: Tabs,
  tag: Tag,
  task_list: TaskList,
  tax_documents: TaxDocuments,
  tax_filing: TaxFiling,
  tax_return: TaxReturn,
  telephone: Telephone,
  toggle: Toggle,
  transaction_alert: TransactionAlert,
  trash: Trash,
  twitter: Twitter,
  ufo: Ufo,
  unlock: Unlock,
  urgent: Urgent,
  urgent_filled: UrgentFilled,
  wallet: Wallet,
}
